/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Outcome of a Parental Control PIN check.
 */
enum PinValidationResult {
  /** The entered PIN matches the account PIN. */
  VALID = "VALID",

  /** The entered PIN does not match, or is not a well-formed PIN. */
  INVALID = "INVALID",

  /** Too many wrong attempts; entry is locked until the cool-down ends. */
  LOCKED_OUT = "LOCKED_OUT",

  /** No usable PIN hash or no crypto support — the PIN cannot be checked. Never unlocks. */
  UNAVAILABLE = "UNAVAILABLE",

  /**
   * The check was superseded (newer check, dialog dismissed, app hidden or
   * sign-out) before it finished. Ignore it: it neither unlocks nor counts as
   * a wrong attempt (WEB-PC-058).
   */
  CANCELLED = "CANCELLED"
}

export { PinValidationResult };
